/**
 * 获取当前时间戳
 *
 * @returns {string} 格式为"HH:mm-yyyyMMdd"的时间字符串
 */
export function getTimeStamp() {
    const now = new Date();

    const hours = now.getHours();
    const minutes = now.getMinutes();
    const date = now.getDate();
    const month = now.getMonth() + 1;
    const year = now.getFullYear();

    const formattedHours = hours.toString().padStart(2, '0');
    const formattedMinutes = minutes.toString().padStart(2, '0');

    const formattedDate = date.toString().padStart(2, '0');
    const formattedMonth = month.toString().padStart(2, '0');

    const timeString = `${formattedHours}:${formattedMinutes}-${year}${formattedMonth}${formattedDate}`;
    return timeString;

}